var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_social_share_24px_",
    "data-name": "icon/social/share_24px ",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 18,
    height: 18,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M10,9.9a1.888,1.888,0,0,0-1.307.541L3.94,7.52A2.419,2.419,0,0,0,4,7.028a2.419,2.419,0,0,0-.06-.492l4.7-2.889A1.938,1.938,0,0,0,10,4.217a2.054,2.054,0,0,0,2-2.108A2.054,2.054,0,0,0,10,0,2.054,2.054,0,0,0,8,2.108a2.419,2.419,0,0,0,.06.492L3.36,5.489A1.938,1.938,0,0,0,2,4.92,2.054,2.054,0,0,0,0,7.028,2.054,2.054,0,0,0,2,9.137a1.938,1.938,0,0,0,1.36-.569l4.747,2.924a2.085,2.085,0,0,0-.053.457A2,2,0,0,0,10,14a2.055,2.055,0,0,0,0-4.1Z",
    transform: "translate(3 2)",
    fill: "#fe9362"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.27475540056cfd350ad74e852fedf6bb.svg";
export { ForwardRef as ReactComponent };